/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Juan Esteban Atehortua Sanchez                             ║
║ juan.atehortua@iudigital.edu.co                            ║
╚════════════════════════════════════════════════════════════╝
*/

import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  Card,
} from "@mui/material";
import { useEffect, useState } from "react";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";

export function RoleCreate({
  open,
  handleClose,
  isFormModified,
  isDisabled,
  getFieldValue,
  handleFieldChange,
  handleSubmit,
  handleRolePermitList,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "600px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography id="modal-modal-title" component="h2">
            Crear rol
          </Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <form onSubmit={handleSubmit}>
          <Box>
            <MDBox
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <MDBox style={{ width: "50%" }}>
                <Typography id="modal-modal-title" variant="h5" component="h2">
                  Nombre:
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  style={{ width: "100%", marginTop: "5px" }}
                  label="Nombre"
                  value={getFieldValue("name")}
                  onChange={(e) => handleFieldChange("name", e.target.value)}
                />
                <Typography
                  id="modal-modal-title"
                  variant="h5"
                  component="h2"
                  style={{ marginTop: "15px" }}
                >
                  Descripción:
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  style={{ width: "100%", marginTop: "5px" }}
                  multiline
                  rows={3}
                  label="Descripción"
                  value={getFieldValue("description")}
                  onChange={(e) => handleFieldChange("description", e.target.value)}
                />
              </MDBox>

              {/*<MDBox style={{ marginLeft: 15, width: "50%" }}>
                <Typography
                  id="modal-modal-title"
                  component="h5"
                  style={{ marginTop: "5px", width: "50%" }}
                >
                  Permisos
                </Typography>

                {handleRolePermitList &&
                  handleRolePermitList.map(([category, permits]) => (
                    <div key={category}>
                      <Typography
                        sx={{
                          display: "inline",
                          fontWeight: "bold",
                          fontSize: 16,
                        }}
                      >
                        {category}
                      </Typography>
                      <ul>
                        {permits &&
                          permits.map(([label, value]) => (
                            <Box key={value} sx={{ py: -1 }}>
                              <Checkbox
                                sx={{ py: -1 }}
                                id={value}
                                name="permissions"
                                value={value}
                                onChange={(e) => handleFieldChange("permissions", e.target.value)}
                              />
                              <Typography
                                sx={{
                                  display: "inline",
                                  fontSize: 16,
                                }}
                                htmlFor={value}
                              >
                                {label}
                              </Typography>
                            </Box>
                          ))}
                      </ul>
                    </div>
                  ))}
                              </MDBox>*/}
            </MDBox>
          </Box>
          <Divider variant="middle" />
          <MDBox
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
            m={-0.5}
            mb={-2}
          >
            <MDButton color="error" onClick={handleClose}>
              Cancelar
            </MDButton>
            <MDButton
              type="submit"
              onClick={handleSubmit}
              disabled={isDisabled || isFormModified}
              color="success"
            >
              Guardar
            </MDButton>
          </MDBox>
        </form>
      </Card>
    </Modal>
  );
}

RoleCreate.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFormModified: PropTypes.bool,
  handleRolePermitList: PropTypes.any,
};
